import React from "react";
import { useNavigate } from "react-router-dom";
import { getProjectById } from "../../../service/MainService";
import noimg from "../../../assets/images/noimg.webp";

const RelatedProjectsProf = ({ userDetails }) => {
  const navigate = useNavigate();

  const navigateToProjectDetail = async (projectId) => {
    if (!projectId) return;
    try {
      const token = localStorage.getItem("accessToken");
      const projectDetails = await getProjectById(projectId, token);
      navigate(`/project/${projectId}`, {
        state: { projectDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  const ownedProjects = userDetails.ProjectList || [];
  const collabProjects = userDetails.CollaborationProjectList || [];

  const allProjects = [
    ...ownedProjects.map((p) => ({ ...p, isOwner: true })),
    ...collabProjects.map((p) => ({ ...p, isOwner: false })),
  ];

  return (
    <>
      {allProjects.length > 0 && (
        <div className="lg:px-40 mt-10 mb-10">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="text-3xl border-r border-gray-400 pr-4">Projects</div>
            <div className="text-gray-500 font-semibold pl-4">
              {allProjects.length} projects
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mt-5">
            {allProjects.map((project, index) => (
              <React.Fragment key={index}>
                <div
                  className="relative cursor-pointer shadow-md"
                  onClick={() =>
                    navigateToProjectDetail(
                      project.projectId || project.ProjectId
                    )
                  }
                >
                  {!project.isOwner && (
                    <span className="absolute top-2 left-2 bg-blue-600 text-white text-[10px] font-bold px-2 py-0.5 rounded shadow z-10">
                      Collaborator
                    </span>
                  )}
                  <img
                    src={
                      project.image1 ||
                      project.Image1 ||
                      (project.imageUrls && project.imageUrls.length > 0
                        ? project.imageUrls[0]
                        : project.ImageUrls && project.ImageUrls.length > 0
                        ? project.ImageUrls[0]
                        : noimg)
                    }
                    alt={project.projectName || project.ProjectName || "Project"}
                    className="w-full h-40 sm:h-60 object-cover"
                    onError={(e) => {
                      e.target.src = noimg;
                    }}
                  />
                  <div className="absolute inset-0 flex flex-col gap-2 items-center justify-end opacity-0 hover:opacity-100 transition-opacity duration-300 bg-black bg-opacity-50 text-white p-2">
                    <p className="text-sm sm:text-lg font-semibold text-center">
                      {project.projectName || project.ProjectName}
                    </p>
                    <p className="text-xs sm:text-sm">
                      {project?.country?.countryName ||
                        project?.Country?.countryName}
                    </p>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RelatedProjectsProf;
